import { useState } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

export default function FormSubmit({
  productOption,
  productOptionList,
  inquiry,
}) {
  const [data, setData] = useState({
    product: {},
    option: {},
    optionValue: [],
    count: 0,
  });
  const [optionList, setOptionList] = useState([]);
  const [showData, setShowData] = useState({ price: 0 });
  const reset = () => {
    setData((prev) => {
      return { ...prev, option: {}, optionValue: "" };
    });
  };
  const optionValue = (id, valueNew) => {
    let temp = optionList;
    temp = temp.map((value) => {
      if (value.id == id) return { ...value, enterValue: valueNew };
      else return value;
    });
    setOptionList(temp);
    setData((prev) => {
      return { ...prev, optionValue: temp };
    });
  };

  //   console.log("object object object", optionList);
  return (
    <form className="w-100 p-3 d-flex flex-wrap">
      <div className="mx-1 w-25 my-2">
        <label>انتخاب محصول</label>
        <Select
          options={productOption}
          onChange={(e) => {
            let temp = productOptionList(e.value);
            setData((prev) => {
              return { ...prev, product: e };
            });
            reset();
            setOptionList(
              temp.map((v) => {
                return { ...v, enterValue: -1 };
              })
            );
          }}
        />
      </div>
      <div className="w-25">
        تعداد
        <input
          value={data?.count}
          className="form-control"
          onChange={(e) =>
            setData((prev) => {
              return { ...prev, count: e.target.value };
            })
          }
        />
      </div>
      <div className="mx-1 my-2">
        <label>انتخاب اپشن</label>
        <div className="d-flex flex-wrap">
          {optionList.map((v, index) => {
            return (
              <div className="d-flex align-items-center px-2">
                <p>{v.label}</p>
                <div className="">
                  {v.type == 1 ? (
                    v?.Option?.map((val, i) => {
                      return (
                        <Form.Check
                          style={{ width: 100 }}
                          inline
                          label={val}
                          name={`group1-${index}`}
                          type={"radio"}
                          id={`inline-${i}-1`}
                          onClick={(e) => {
                            optionValue(v.id, val);
                          }}
                        />
                      );
                    })
                  ) : (
                    <input
                      className="form-control"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        optionValue(v.id, e.target.value);
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-100">
        <button
          className="btn bg-primary text-light"
          onClick={(e) => {
            e.preventDefault();
            let result = inquiry(optionList, data?.product?.value, data.count);
            setShowData(result);
          }}
        >
          استعلام
        </button>
      </div>
      <div className="w-100 border rounded p-2 my-2">
        <div>قیمت محصول: {showData?.price}</div>
      </div>
    </form>
  );
}
